import { CopilotChannelContext } from 'copilot-toolkit/channel/CopilotChannelContext';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import emptyFunction from 'react-utils/emptyFunction';
import { useCallback, useContext, useState } from 'react';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import { useHostAppName } from './hooks/useHostAppName';
import { buildModalUrl } from './utils/buildModalUrl';

// @ts-expect-error Not Typed
import { IFrame } from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const BREEZE_PROJECTS_MODAL_WIDTH = 1200;
const BREEZE_PROJECTS_MODAL_HEIGHT = 780;
const BreezeProjectsModalHost = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [iframeSrc, setIframeSrc] = useState(undefined);
  const hostAppName = useHostAppName();
  const contextValue = useContext(CopilotChannelContext);
  const instanceId = contextValue === null || contextValue === void 0 ? void 0 : contextValue.instanceId;
  const handleMessage = useCallback(message => {
    var _message$payload;
    if (((_message$payload = message.payload) === null || _message$payload === void 0 ? void 0 : _message$payload.type) === MSG_TYPE_MODAL_DIALOG_CLOSE) {
      setIsVisible(false);
      setIframeSrc(undefined);
    }
  }, []);
  const handleOpen = useCallback(data => {
    let url = buildModalUrl('/breeze-projects-ui', hostAppName, instanceId);
    if (data !== null && data !== void 0 && data.route) {
      url += `&route=${encodeURIComponent(data.route)}`;
    }
    if (data !== null && data !== void 0 && data.projectId) {
      url += `&projectId=${encodeURIComponent(String(data.projectId))}`;
    }
    if (data !== null && data !== void 0 && data.threadId) {
      url += `&threadId=${encodeURIComponent(String(data.threadId))}`;
    }
    setIframeSrc(url);
    setIsVisible(true);
  }, [hostAppName, instanceId]);
  useSubscribeToCopilotChannel('OPEN_BREEZE_PROJECTS_MODAL', handleOpen);
  const containerStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1112,
    display: isVisible ? 'block' : 'none',
    pointerEvents: 'auto',
    borderRadius: 'var(--trellis-border-radius-transitional-floating)',
    overflow: 'hidden',
    boxShadow: 'var(--trellis-box-shadow-300)',
    width: `min(calc(100vw - 200px), ${BREEZE_PROJECTS_MODAL_WIDTH}px)`,
    height: `${BREEZE_PROJECTS_MODAL_HEIGHT}px`
  };
  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    children: iframeSrc && /*#__PURE__*/_jsx(IFrame, {
      appName: "breeze-projects-ui",
      height: isVisible ? BREEZE_PROJECTS_MODAL_HEIGHT : 0,
      initTimeout: 20000,
      name: "breeze-projects-modal",
      onMessage: handleMessage,
      onReady: emptyFunction,
      scrolling: false,
      src: iframeSrc,
      width: isVisible ? '100%' : 0
    })
  });
};
export default BreezeProjectsModalHost;